import type {UntypedPayload} from 'constants/events/EventPayloadUtils';

export const TEMPLATE_EVENT_PAYLOADS = {
  TEMPLATE_CLOSE: {} as UntypedPayload,
  TEMPLATE_DELETE: {} as UntypedPayload,
  TEMPLATE_DELETE_COMPLETED: {} as UntypedPayload,
  TEMPLATE_DELETE_FAILED: {} as UntypedPayload,
  TEMPLATE_FETCH_VERSIONS: {} as UntypedPayload,
  TEMPLATE_FETCH_VERSIONS_COMPLETED: {} as UntypedPayload,
  TEMPLATE_FETCH_VERSIONS_FAILED: {} as UntypedPayload,
  TEMPLATE_LOAD_VERSION: {} as UntypedPayload,
  TEMPLATE_LOAD_VERSION_COMPLETED: {} as UntypedPayload,
  TEMPLATE_LOAD_VERSION_FAILED: {} as UntypedPayload,
  TEMPLATE_OPEN: {} as UntypedPayload,
  TEMPLATE_OPEN_COMPLETED: {} as UntypedPayload,
  TEMPLATE_OPEN_FAILED: {} as UntypedPayload,
  TEMPLATE_REGISTER_OBJECTS: {} as UntypedPayload,
  TEMPLATE_RESET_TO_OPEN_VERSION: {} as UntypedPayload,
  TEMPLATE_REVERT: {} as UntypedPayload,
  TEMPLATE_SAVE: {} as UntypedPayload,
  TEMPLATE_SAVE_COMPLETED: {} as UntypedPayload,
  TEMPLATE_SAVE_FAILED: {} as UntypedPayload,
  TEMPLATE_UPDATE: {} as UntypedPayload,
} as const;

export type TemplateEventPayload = typeof TEMPLATE_EVENT_PAYLOADS;
